import { render, staticRenderFns } from "./uokoVisualServiceEdit.vue?vue&type=template&id=8b26b454&scoped=true"
import script from "./uokoVisualServiceEdit.vue?vue&type=script&lang=js"
export * from "./uokoVisualServiceEdit.vue?vue&type=script&lang=js"
import style0 from "./uokoVisualServiceEdit.vue?vue&type=style&index=0&id=8b26b454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b26b454",
  null
  
)

export default component.exports